<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="license._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ license.title }}</h3>
            <p class="text-center">{{ license.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات اشتراک</h4>
          </div>
          <div class="widget-body">
            <form id="licenseForm" class="form-horizontal">
              <!-- license name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام اشتراک</label>
                <div class="col-lg-6">
                  <input type="text" name="licenseName" class="form-control" v-model="license.title" />
                </div>
              </div>

              <!-- license price -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد روز</label>
                <div class="col-lg-6">
                  <input type="number" name="force" class="form-control" min="1" v-model="license.period" />
                </div>
              </div>

              <!-- license price -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">هزینه</label>
                <div class="col-lg-6">
                  <input type="number" name="force" class="form-control" min="1" v-model="license.price" />
                </div>
              </div>

              <!-- license discount -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تخفیف</label>
                <div class="col-lg-6">
                  <input type="number" name="force" class="form-control" min="1" v-model="license.discount" />
                </div>
              </div>

              <!-- license discount -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">سکه</label>
                <div class="col-lg-6">
                  <input type="number" name="coin" class="form-control" min="0" v-model="license.coin" />
                </div>
              </div>

              <!-- license order -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">اولویت نمایش</label>
                <div class="col-lg-6">
                  <input type="number" name="force" class="form-control" min="1" v-model="license.order" />
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت اشتراک</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="license.isAvailable">فعال</option>
                    <option value="false" :selected="!license.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- is default -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">اشتراک دیفالت</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="isDefault" v-model="license.isDefault" />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/licenses">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import licenseService from '../../../../services/license';
export default {
  name: 'licensedetail',
  data() {
    return {
      license: {},
    };
  },
  created() {
    if (this.$route.query.id) this.getLicense(this.$route.query.id);
  },
  methods: {
    async getLicense(id) {
      try {
        const license = await licenseService.findLicenseById(id);
        this.license = license;
        console.log(license);
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('licenseForm');
      const body = this.license;
      body.isAvailable = form.isAvailable.value == 'true';
      let id;
      try {
        if (this.$route.query.id) {
          await licenseService.updateLicense(body);
          id = this.$route.query.id;
        } else {
          const sarvice = await licenseService.creatLicense(body);
          id = sarvice._id;
          this.$route.query.id = id;
        }

        this.getLicense(id);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
